import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import UploadService from 'services/upload-service';
import apiClient from 'helpers/api-client';
import { photoEdited } from 'reducers/photos';

const useFetchAnnotations = ({ photoId }) =>
  useCallback(
    async () => {
      try {
        const apiData = await apiClient.get(`images/${photoId}/annotations`);
        return apiData.data;
      } catch (e) {
        return {};
      }
    },
    [photoId],
  );

const useSaveAnnotations = ({ photoId }) => {
  const dispatch = useDispatch();

  return useCallback(
    async ({ jsonObject, dataURL = null }) => {
      // 1. Create optimisticEdit (if possible)
      if (dataURL) {
        dispatch(
          photoEdited({
            photoId,
            optimisticUri: dataURL,
          }),
        );
      }

      // 2. Upload to S3 (if necessary)
      let remoteURL;
      if (dataURL !== null) {
        remoteURL = await new UploadService().uploadDataURLToS3(dataURL);
      }

      // 3. Post to API
      const { path, body } = remoteURL
        ? {
            path: `images/${photoId}/annotated_images`,
            body: { annotation: { data: jsonObject, uri: remoteURL } },
          }
        : {
            path: `images/${photoId}/annotations`,
            body: { annotation: { data: jsonObject } },
          };

      await apiClient.post(path, body);
    },
    [photoId, dispatch],
  );
};

export { useFetchAnnotations, useSaveAnnotations };
